<template>
  <section>
    <div class="table-responsive mt-0">
      <table class="table w-full table-data min-w-table">
        <thead>
          <tr>
            <th v-text="'Title'" />
            <th v-text="'Created'" />
            <th v-text="'Status'" />
            <th v-text="'Available Until'" />
            <th v-text="'Download'" />
          </tr>
        </thead>
        <tbody v-if="exports.length">
          <tr
            is="Row"
            v-for="item in exports"
            :key="item.uuid"
            :item="item"
          />
        </tbody>
        <tbody v-else>
          <tr>
            <td
              class="text-center"
              colspan="5"
              v-text="'No files currently available.'"
            />
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script type="text/babel">
import Row from 'Export/Resources/assets/js/components/ExportRow'

export default {
  name: 'ExportsTable',
  components: {
    Row,
  },
  props: {
    exports: {
      type: Array,
      required: true,
    },
  },
}
</script>
